import React, { useContext, useEffect, useMemo, useState } from "react";
import SellerSidebar from "./common/SellerSidebar";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import CommanPagination from "../pages/common/CommanPagination/CommanPagination";
import { organizationDetail } from "../Context/SelectedOrganization";
import axiosClient from "../Services/Axios/axios";
import { BeatLoader } from "react-spinners";
import DateFormatter from "../pages/common/DateFormatter/DateFormatter";
import countryList from "react-select-country-list";
import PhoneInput from "react-country-phone-input";
import Swal from "sweetalert2";
import { FaTrash } from "react-icons/fa";

function Directory() {
  //   const { organizationData } = useContext(organizationDetail);
  const [loader, setLoader] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { organizationData } = useContext(organizationDetail);

  const [businessStatus, setBusinessStatus] = useState("none");
  const [editable, setEditable] = useState("edit");
  const [rejectedReason, setRejectedReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [isPreview, setIsPreview] = useState(false);
  const [errors, setErrors] = useState({});
  const [showModifyForm, setShowModifyForm] = useState(false);

  const [uploadedFiles, setUploadedFiles] = useState([]);

  const [companyRegistration, setCompanyRegistration] = useState({
    companyRegistration: "",
  });
  const [NGOLicense, setNGOLicense] = useState({
    ngo_license: "",
  });
  const [countryData, setCountryData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [errorsValidation, setErrorsValidation] = useState({});
  const [organizationDataNew, setOrganizationDataNew] = useState({
    organization_name: "",
    organization_location: "",
    organization_email: "",
    organization_mobile_no: "",
    organization_mobileCode: "",
    organization_website: "",
    organization_type: "ngo",
    country: "",
    country_id: "",
    about_organization: "",
    organization_banner_image: "",
    company_image: "",
    company_logo: "",
    fullMobile: "",
    category_id: "",
    organization_documents: [],
    social_media: [{ name: "Facebook", value: "" }],
  });
  const options = useMemo(() => countryList().getData(), []);

  const handleProfile = async () => {
    const response = await axiosClient.get(
      `/users/${process.env.REACT_APP_API_VERSION}/getByID`
    );
    if (!response.data.error) {
      localStorage.setItem("userData", JSON.stringify(response.data.data));
    }
  };
  const handleMobileChange = (value, country) => {
    setOrganizationDataNew({
      ...organizationDataNew,
      fullMobile: value,
      organization_mobile_no: value.slice(country.dialCode.length),
      organization_mobileCode: `+${country.dialCode}`,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let formIsValid = true;
    let errors = {};

    /** ----------------------------
      * Validations
        ---------------------------- */

    if (!organizationDataNew.organization_name) {
      formIsValid = false;
      errors.organization_name = "Organisation name is required";
    }

    if (!organizationDataNew.organization_email) {
      formIsValid = false;
      errors.organization_email = "Organization email is required";
    } else if (!/\S+@\S+\.\S+/.test(organizationDataNew.organization_email)) {
      formIsValid = false;
      errors.organization_email = "Organization email is invalid";
    }

    if (!organizationDataNew.organization_mobile_no) {
      formIsValid = false;
      errors.organization_mobile_no = "Organization mobile number is required";
    }

    if (!organizationDataNew.organization_website) {
      formIsValid = false;
      errors.organization_website = "Website is required";
    }

    if (!organizationDataNew.about_organization) {
      formIsValid = false;
      errors.about_organization = "About organization is required";
    }

    if (!organizationDataNew.organization_location) {
      formIsValid = false;
      errors.organization_location = "Organization location is required";
    }

    if (!organizationDataNew.fullMobile) {
      formIsValid = false;
      errors.fullMobile = "Full mobile number is required";
    }
    if (!organizationDataNew.country_id) {
      formIsValid = false;
      errors.organization_country = "Country is required";
    }
    if (!organizationDataNew.category_id) {
      formIsValid = false;
      errors.category_name = "Category is required";
    }
    if (!organizationDataNew.organization_type) {
      formIsValid = false;
      errors.organization_type = "Organization type is required";
    }

    setErrorsValidation(errors);
    if (!formIsValid) return;

    //   /** ----------------------------
    //    * API Call
    //    ---------------------------- */
    try {
      setLoading(true);
      // if (businessStatus === "rejected") {
      const response = await axiosClient.post(
        `company/${process.env.REACT_APP_API_VERSION}/update-company-details`,
        {
          id: organizationData.id,
          status: 3,
          organization_name: organizationDataNew.organization_name,
          organization_location: organizationDataNew.organization_location,
          organization_email: organizationDataNew.organization_email,
          organization_mobile_no: organizationDataNew.organization_mobile_no,
          organization_mobileCode: organizationDataNew.organization_mobileCode,
          organization_type: organizationDataNew.organization_type,
          country: organizationDataNew.country,
          country_id: organizationDataNew.country_id,
          category_id: organizationDataNew.category_id,
          organization_website: organizationDataNew.organization_website,
          about_organization: organizationDataNew.about_organization,
          company_image: organizationDataNew.company_image,
          organization_banner_image:
            organizationDataNew.organization_banner_image,
          company_registration: companyRegistration.companyRegistration,
          ngo_license: NGOLicense.ngo_license,
          social_links: organizationDataNew.social_media.map((item) => ({
            platform: item.name,
            url: item.value,
          })),
          organization_documents: uploadedFiles.map((file) => ({
            document_url: file,
          })),
        }
      );
      if (!response.data.error)
        Swal.fire({
          icon: "success",
          title: response.data.message || "Organization updated successfully",
        });
      setBusinessStatus("pending");
      handleProfile();
      navigate("/company-list");
      // }
      // else {
      //   const response = await axiosClient.post(
      //     `company/${process.env.REACT_APP_API_VERSION}/create-company-details`,
      //     {
      //       organization_name: organizationDataNew.organization_name,
      //       organization_location: organizationDataNew.organization_location,
      //       organization_email: organizationDataNew.organization_email,
      //       organization_mobile_no: organizationDataNew.organization_mobile_no,
      //       organization_mobileCode: organizationDataNew.organization_mobileCode,
      //       organization_type: organizationDataNew.organization_type,
      //       country: organizationDataNew.country,
      //       country_id: organizationDataNew.country_id,
      //       organization_website: organizationDataNew.organization_website,
      //       about_organization: organizationDataNew.about_organization,
      //       company_registration: companyRegistration.companyRegistration,
      //       ngo_license: NGOLicense.ngo_license,
      //       social_links: organizationDataNew.social_media.map((item) => ({
      //         platform: item.name,
      //         url: item.value,
      //       })),
      //       organization_documents: uploadedFiles.map((file) => ({
      //         document_url: file,
      //       })),
      //     }
      //   );

      //   if (!response.data.error) {
      //     Swal.fire({
      //       icon: "success",
      //       title: response.data.message || "Organization created successfully",
      //     });
      //     setBusinessStatus("pending");
      //     handleProfile();
      //     setIsPreview(true);
      //   }
      // }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Failed to update profile",
        text: error?.response?.data?.message || "Something went wrong",
      });
    } finally {
      setLoading(false);
    }
  };

  const confirmationReject = (type) => {
    console.log(type);
    if (type === "yes") {
      setEditable("edit");
      Swal.fire({
        icon: "success",
        title: "Modify Application",
        text: "You can only modify and re-apply your application now.",
      });
    }
    if (type === "no") {
      setEditable("disable");
      Swal.fire({
        icon: "warning",
        title: "Modify Application",
        text: "You have chosen not to modify your application. You will not be able to re-apply.",
      });
    }
  };

  // ✅ Handle multiple social links
  const handleSocialMediaChange = (index, field, value) => {
    const updatedSocialMedia = organizationDataNew.social_media.map((item, i) =>
      i === index ? { ...item, [field]: value } : item
    );
    setOrganizationDataNew((prevState) => ({
      ...prevState,
      social_media: updatedSocialMedia,
    }));
    setErrors((prevState) => {
      const updatedErrors = { ...prevState };
      updatedErrors[`social_media_${index}_${field}`] = "";
      return updatedErrors;
    });
  };

  const addSocialLink = () => {
    setOrganizationDataNew({
      ...organizationDataNew,
      social_media: [
        ...organizationDataNew.social_media,
        { name: "", value: "" },
      ],
    });
  };

  const removeSocialLink = (index) => {
    const updated = [...organizationDataNew.social_media];
    updated.splice(index, 1);
    setOrganizationDataNew({ ...organizationDataNew, social_media: updated });
  };

  const uploadFile = async (file, onSuccess) => {
    try {
      const maxFileSize = 5 * 1024 * 1024; // 5MB
      if (file.size > maxFileSize) {
        Swal.fire({
          icon: "error",
          title: "File size exceeds 5MB",
          text: "Please upload a file smaller than 5MB.",
        });
        return;
      }

      const formData = new FormData();
      formData.append("image", file);

      const response = await axiosClient.post("users/uploadimg", formData);
      if (!response.data.error) {
        onSuccess(response.data.file);
      } else {
        Swal.fire({
          icon: "error",
          title: "Upload failed",
          text: response.data.message || "Something went wrong!",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Upload failed",
        text: error.message || "Something went wrong!",
      });
    }
  };
  // ✅ Handle single file (display/banner)
  const handleFileChange = (e, name) => {
    const file = e.target.files[0];
    if (!file) return;

    uploadFile(file, (uploadedFile) => {
      if (name === "banner") {
        setOrganizationDataNew({
          ...organizationDataNew,
          organization_banner_image: uploadedFile,
        });
      }
      if (name === "display") {
        setOrganizationDataNew({
          ...organizationDataNew,
          company_image: uploadedFile,
        });
      }
    });
  };
  const addNewFileField = () => {
    setUploadedFiles([...uploadedFiles, ""]);
  };

  const removeFileField = (index) => {
    const updated = [...uploadedFiles];
    updated.splice(index, 1);
    setUploadedFiles(updated);
  };

  const handleEdit = () => setIsPreview(false);

  const singleOrganizationData = async () => {
    try {
      setLoading(true);
      const response = await axiosClient.get(
        `company/${process.env.REACT_APP_API_VERSION}/organization/${organizationData.id}`
      );
      if (!response.data.error) {
        setRejectedReason(response.data.data.reject_reason || "");
        setUploadedFiles(
          response.data.data.organization_documents.map(
            (doc) => doc.document_url
          )
        );
        setOrganizationDataNew({
          ...organizationDataNew,
          organization_name: response.data.data.organization_name,
          organization_location: response.data.data.organization_location,
          organization_email: response.data.data.organization_email,
          organization_mobile_no: response.data.data.organization_mobile_no,
          organization_mobileCode: response.data.data.organization_mobileCode,
          organization_website: response.data.data.organization_website,
          fullMobile: `${response.data.data.organization_mobileCode}${response.data.data.organization_mobile_no}`,
          country: response.data.data.country,
          country_id: response.data.data.country_id,
          organization_type: response.data.data.organization_type,
          about_organization: response.data.data.about_organization,
          category_id: response.data.data.category_id,
          organization_banner_image:
            response.data.data.organization_banner_image,
          company_image: response.data.data.company_image,
          social_media: response.data.data.social_links.map((item) => ({
            name: item.platform,
            value: item.url,
          })),
        });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const getCountryData = async () => {
    const response = await axiosClient.get(`/country/get-selected-country`);
    if (!response.data.error) {
      setCountryData(response.data.data);
    }
  };

  const getCategoryData = async () => {
    const response = await axiosClient.get(
      `company/${process.env.REACT_APP_API_VERSION}/categories`
    );
    if (!response.data.error) {
      setCategoryData(response.data.data);
    }
  };

  useEffect(() => {
    getCountryData();
    getCategoryData();
    singleOrganizationData();
    if (location.state?.data) {
      setBusinessStatus(
        location?.state?.data.status === 2 ? "rejected" : "none"
      );
      setEditable(location?.state?.data.status === 2 ? "disable" : "edit");
    }
  }, [location, organizationData]);

  return (
    <>
      <div className="all_suport_bg manages_top">
        <section className="ser_v_araeea profiles">
          <div className="container">
            <div className="bradcams">
              <span className="bothss">
                <Link to="">Dashboard</Link>{" "}
                <img src="/images/brd_rowwo.png" alt="" /> Directory
              </span>
            </div>
            <div className="row">
              <div className="col-lg-3 mb_view_hide">
                <SellerSidebar />
              </div>

              {loading ? (
                <div className="member-loader">
                  <BeatLoader color="#097C81" />
                </div>
              ) : (
                <div className="col-lg-9 order-list">
                  <div
                    className="d-flex justify-content-between align-items-center mb-3"
                    style={{ gap: "12px" }}
                  >
                    <h4 style={{ fontWeight: "600" }}>Company Details</h4>
                    {/* Left: Search + Filter */}
                  </div>

                  {/* Order List */}
                  <div className="form_boxx profilss">
                    <div className="form_arar mt-0">
                      <div className="d-flex justify-content-between mb-3">
                        <section className="col-lg-12" id="careers_pgs">
                          <div>
                            <form
                              className="register-form"
                              onSubmit={handleSubmit}
                            >
                              {/* Organisation Details */}
                              <div className="sub-header">
                                Organisation Details
                              </div>{" "}
                              <hr />
                              <div className="form-grid">
                                <div>
                                  <label>Organisation Name</label>
                                  <input
                                    maxLength={50}
                                    name="organization_name"
                                    className={`form-control ${
                                      errorsValidation.organization_name
                                        ? "input-error"
                                        : ""
                                    }`}
                                    placeholder="Organisation Name"
                                    value={
                                      organizationDataNew.organization_name
                                    }
                                    onChange={(e) => {
                                      setErrorsValidation({
                                        ...errorsValidation,
                                        organization_name: "",
                                      });
                                      setOrganizationDataNew({
                                        ...organizationDataNew,
                                        organization_name: e.target.value,
                                      });
                                    }}
                                    disabled={editable === "disable"}
                                  />
                                  {errors.organization_name && (
                                    <span className="error">
                                      {errors.organization_name}
                                    </span>
                                  )}
                                </div>
                                <div>
                                  <label>Email Address</label>
                                  <input
                                    type="email"
                                    name="email"
                                    className={`form-control ${
                                      errorsValidation.organization_email
                                        ? "input-error"
                                        : ""
                                    }`}
                                    placeholder="Email Address"
                                    value={
                                      organizationDataNew.organization_email
                                    }
                                    onChange={(e) => {
                                      setErrorsValidation({
                                        ...errorsValidation,
                                        organization_email: "",
                                      });
                                      setOrganizationDataNew({
                                        ...organizationDataNew,
                                        organization_email: e.target.value,
                                      });
                                    }}
                                    disabled={editable === "disable"}
                                  />
                                  {errorsValidation.organization_email && (
                                    <span className="error">
                                      {errorsValidation.organization_email}
                                    </span>
                                  )}
                                </div>
                                <div>
                                  <label>Location</label>
                                  <input
                                    name="location"
                                    className={`form-control ${
                                      errorsValidation.organization_location
                                        ? "input-error"
                                        : ""
                                    }`}
                                    placeholder="Location"
                                    value={
                                      organizationDataNew.organization_location
                                    }
                                    onChange={(e) => {
                                      setErrorsValidation({
                                        ...errorsValidation,
                                        organization_location: "",
                                      });
                                      setOrganizationDataNew({
                                        ...organizationDataNew,
                                        organization_location: e.target.value,
                                      });
                                    }}
                                    disabled={editable === "disable"}
                                  />
                                  {errorsValidation.organization_location && (
                                    <span className="error">
                                      {errorsValidation.organization_location}
                                    </span>
                                  )}
                                </div>
                                <div>
                                  <label>Country</label>
                                  <select
                                    name="country"
                                    value={organizationDataNew.country_id}
                                    onChange={(e) => {
                                      setErrorsValidation({
                                        ...errorsValidation,
                                        organization_country: "",
                                      });
                                      setOrganizationDataNew({
                                        ...organizationDataNew,
                                        country_id: e.target.value,
                                        country:
                                          e.target.options[
                                            e.target.selectedIndex
                                          ].text,
                                      });
                                    }}
                                    disabled={editable === "disable"}
                                  >
                                    <option value="">Select a country</option>
                                    {countryData.map((res, i) => (
                                      <option key={i} value={res.id}>
                                        {res.name}
                                      </option>
                                    ))}
                                  </select>
                                  {errorsValidation.country && (
                                    <span className="error">
                                      {errorsValidation.country}
                                    </span>
                                  )}
                                </div>

                                <div>
                                  <label>Mobile No.</label>
                                  <PhoneInput
                                    className={`react-tel-input ${
                                      errorsValidation.organization_mobile_no
                                        ? "input-error"
                                        : ""
                                    }`}
                                    placeholder="Enter Phone Number"
                                    country={"th"}
                                    value={organizationDataNew.fullMobile || "+66"}
                                    onChange={(value, country) => {
                                      setErrorsValidation({
                                        ...errorsValidation,
                                        organization_mobile_no: "",
                                      });

                                      handleMobileChange(value, country);
                                    }}
                                    disabled={editable === "disable"}
                                  />
                                  {errorsValidation.organization_mobile_no && (
                                    <span className="error">
                                      {errorsValidation.organization_mobile_no}
                                    </span>
                                  )}
                                </div>
                                <div className="">
                                  <label>Website</label>
                                  <input
                                    name="organization_website"
                                    className={`form-control ${
                                      errorsValidation.organization_website
                                        ? "input-error"
                                        : ""
                                    }`}
                                    placeholder="Website"
                                    value={
                                      organizationDataNew.organization_website
                                    }
                                    onChange={(e) => {
                                      setErrorsValidation({
                                        ...errorsValidation,
                                        organization_website: "",
                                      });
                                      setOrganizationDataNew({
                                        ...organizationDataNew,
                                        organization_website: e.target.value,
                                      });
                                    }}
                                    disabled={editable === "disable"}
                                  />
                                  {errorsValidation.organization_website && (
                                    <span className="error">
                                      {errorsValidation.organization_website}
                                    </span>
                                  )}
                                </div>

                                <div>
                                  <label>Category</label>
                                  <select
                                    name="country"
                                    value={organizationDataNew.category_id}
                                    onChange={(e) => {
                                      setErrorsValidation({
                                        ...errorsValidation,
                                        category_name: "",
                                      });
                                      setOrganizationDataNew({
                                        ...organizationDataNew,
                                        category_id: e.target.value,
                                        category_name:
                                          e.target.options[
                                            e.target.selectedIndex
                                          ].text,
                                      });
                                    }}
                                    disabled={editable === "disable"}
                                  >
                                    <option value="">Select a category</option>
                                    {categoryData.map((res, i) => (
                                      <option key={i} value={res.id}>
                                        {res.title}
                                      </option>
                                    ))}
                                  </select>
                                  {errorsValidation.category_name && (
                                    <span className="error">
                                      {errorsValidation.category_name}
                                    </span>
                                  )}
                                </div>
                                <div className="">
                                  <label>Organisation type</label>
                                  <div className="form-group" id="rediiobnt">
                                    <div class="rdo_boxx marg_bothss">
                                      <p>
                                        <input
                                          name="role_type"
                                          value="ngo"
                                          type="radio"
                                          id="ngo"
                                          checked={
                                            organizationDataNew.organization_type ===
                                            "ngo"
                                          }
                                          onChange={(e) =>
                                            setOrganizationDataNew({
                                              ...organizationDataNew,
                                              organization_type: e.target.value,
                                            })
                                          }
                                        />
                                        <label for="ngo">NGO</label>
                                      </p>
                                      <p>
                                        <input
                                          type="radio"
                                          id="company"
                                          name="role_type"
                                          value="company"
                                          // value={organizationData.organization_type}
                                          checked={
                                            organizationDataNew.organization_type ===
                                            "company"
                                          }
                                          onChange={(e) =>
                                            setOrganizationDataNew({
                                              ...organizationDataNew,
                                              organization_type: e.target.value,
                                            })
                                          }
                                        />
                                        <label for="company">Company</label>
                                      </p>
                                    </div>
                                    {errorsValidation.organization_type && (
                                      <span className="error">
                                        {errorsValidation.organization_type}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                              {/* Social Media Links */}
                              <div className="sub-header">
                                Social Media Links
                                <button
                                  type="button"
                                  className="add-link-btn"
                                  onClick={addSocialLink}
                                >
                                  Add Link
                                </button>
                              </div>
                              <hr />
                              {isPreview ? (
                                <div className="social-preview-list">
                                  {organizationDataNew.social_media.map(
                                    (item, i) => (
                                      <div key={i} className="social-row">
                                        <strong>{item.name}</strong>
                                        <span>{item.value}</span>
                                      </div>
                                    )
                                  )}
                                </div>
                              ) : (
                                organizationDataNew.social_media.map(
                                  (item, idx) => (
                                    <div key={idx} className="social-links">
                                      <div className="social-input">
                                        <label>Choose Platform</label>
                                        <select
                                          name="platform"
                                          value={item.name || "Facebook"} // Ensure default is an empty string
                                          onChange={(e) =>
                                            handleSocialMediaChange(
                                              idx,
                                              "name",
                                              e.target.value
                                            )
                                          }
                                          disabled={editable === "disable"}
                                        >
                                          <option value="">
                                            Choose platform
                                          </option>
                                          <option>Facebook</option>
                                          <option>Instagram</option>
                                          <option>LinkedIn</option>
                                          <option>Twitter</option>
                                        </select>
                                      </div>

                                      <div className="social-input">
                                        <label>Enter Link</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Enter URL"
                                          value={item.value || ""} // Ensure no undefined value
                                          onChange={(e) =>
                                            handleSocialMediaChange(
                                              idx,
                                              "value",
                                              e.target.value
                                            )
                                          }
                                          disabled={editable === "disable"}
                                        />
                                        {errors[
                                          `social_media_${idx}_value`
                                        ] && (
                                          <small className="text-danger">
                                            {
                                              errors[
                                                `social_media_${idx}_value`
                                              ]
                                            }
                                          </small>
                                        )}
                                      </div>

                                      {idx > 0 && (
                                        <button
                                          type="button"
                                          className="social-delete-btn"
                                          onClick={() => removeSocialLink(idx)}
                                        >
                                          <FaTrash size={18} />
                                        </button>
                                      )}
                                    </div>
                                  )
                                )
                              )}
                              {/* Description */}
                              <div className="sub-header">Description</div>
                              <hr />
                              <>
                                <label>About Organisation</label>
                                <textarea
                                  name="about"
                                  className={`form-control ${
                                    errorsValidation.about_organization
                                      ? "input-error"
                                      : ""
                                  }`}
                                  rows="5"
                                  value={
                                    organizationDataNew.about_organization || ""
                                  }
                                  onChange={(e) => {
                                    setErrorsValidation({
                                      ...errorsValidation,
                                      about_organization: "",
                                    });
                                    setOrganizationDataNew({
                                      ...organizationDataNew,
                                      about_organization: e.target.value,
                                    });
                                  }}
                                  disabled={editable === "disable"}
                                  placeholder="Write about your organization"
                                />
                                {errorsValidation.about_organization && (
                                  <span className="error-message">
                                    {errorsValidation.about_organization}
                                  </span>
                                )}
                              </>
                              <>
                                <div className="sub-header">Upload Images</div>
                                <hr />

                                <div className="dir-upload-img">
                                  <div className="dir-upload-input">
                                    <h5>Display Image</h5>
                                    <label className="upload-input upload-control">
                                      {organizationDataNew.company_image ? (
                                        <img
                                          src={
                                            organizationDataNew.company_image
                                          }
                                          alt="banner"
                                          className="banner-preview"
                                        />
                                      ) : (
                                        <>
                                          <span className="upload-placeholder">
                                            Upload file
                                          </span>
                                          <input
                                            type="file"
                                            accept=".pdf,.png,.jpg,.jpeg,.doc,.docx"
                                            onChange={(e) =>
                                              handleFileChange(e, "display")
                                            }
                                          />
                                        </>
                                      )}

                                      {!organizationDataNew.organization_banner_image && (
                                        <img
                                          className="upload-icon"
                                          src="/images/pin.png"
                                          alt="attach"
                                        />
                                      )}
                                    </label>
                                    {/* <label className="upload-input upload-control">
                                    <span className="upload-placeholder">
                                      Upload file
                                    </span>
                                    <input
                                      type="file"
                                      accept=".pdf,.png,.jpg,.jpeg,.doc,.docx"
                                      onChange={(e) =>
                                        handleFileChange(e, "display")
                                      }
                                    />
                                    <img
                                      className="upload-icon"
                                      src="/images/pin.png"
                                      alt="attach"
                                    />
                                  </label> */}
                                  </div>

                                  <div className="dir-upload-input">
                                    <h5>Banner Image</h5>

                                    <label className="upload-input upload-control">
                                      {organizationDataNew.organization_banner_image ? (
                                        <img
                                          src={
                                            organizationDataNew.organization_banner_image
                                          }
                                          alt="banner"
                                          className="banner-preview"
                                        />
                                      ) : (
                                        <>
                                          <span className="upload-placeholder">
                                            Upload file
                                          </span>
                                          <input
                                            type="file"
                                            accept=".pdf,.png,.jpg,.jpeg,.doc,.docx"
                                            onChange={(e) =>
                                              handleFileChange(e, "banner")
                                            }
                                          />
                                        </>
                                      )}

                                      {!organizationDataNew.organization_banner_image && (
                                        <img
                                          className="upload-icon"
                                          src="/images/pin.png"
                                          alt="attach"
                                        />
                                      )}
                                    </label>
                                  </div>
                                </div>
                              </>
                              <div className="my_profiless my-5 text-white p-4">
                                <div className="d-flex justify-content-between align-items-center">
                                  <div>
                                    <div className="d-flex align-items-center">
                                      <h5 className="text-white mb-2">
                                        Request for Badge
                                      </h5>
                                      <img
                                        src="/images/gold_medal.png"
                                        alt="Badge"
                                        style={{
                                          width: "35px",
                                          marginLeft: "10px",
                                        }}
                                      />
                                    </div>
                                    <h6 className="text-white pr-2">
                                      You can request the authorities for badge
                                      and if we felt you’re deserving you’ll
                                      surely get one
                                    </h6>
                                  </div>
                                  <div className="proceed-btn-wrapper">
                                    <Link to=" ">
                                      <button className="pt-2 pb-2 pl-4 pr-4 ml-4 mr-4">
                                        Request
                                      </button>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                              <div className="submit-btn-container">
                                <button type="submit" className="submit-btn">
                                  Update Profile
                                </button>
                              </div>
                            </form>
                          </div>
                        </section>
                      </div>
                      {/* Scroll wrapper */}
                    </div>
                  </div>
                  {/* Pagination */}
                </div>
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default Directory;
